import { centerable as n } from "../decorators/centerable.js";
import { stylable as a } from "../decorators/stylable.js";
import { ALIGN_CLASSES_INVERSE as r } from "../../constants.js";
const s = a(
  n({
    inline: !1,
    content: "inline*",
    group: "block",
    attrs: {
      type: { default: "small" }
    },
    parseDOM: [
      {
        tag: "small",
        getAttrs(t) {
          let e;
          return t.parentElement && t.parentElement.classList.forEach((l) => {
            r[l] && (e = r[l]);
          }), { alignment: e };
        }
      }
    ],
    toDOM() {
      return ["small", 0];
    }
  })
);
export {
  s as smallSpec
};
